export default [
    {
        path: '/company/users',
        name: 'CompanyUsers',
        component: () => import('@/views/Company/Users.vue'),
        meta: { permission: 'users.view' }
    },
    {
        path: '/company/user/create',
        name: 'CreateCompanyUser',
        component: () => import('@/views/Company/UserBuilder.vue'),
        meta: { permission: 'users.create' }
    },
    {
        path: '/company/user/:userId/profile',
        name: 'UserProfile',
        component: () => import('@/views/Company/UserProfile.vue'),
        meta: { permission: 'users.view' }
    },
    {
        path: '/company/user/:userId/edit',
        name: 'EditCompanyUser',
        component: () => import('@/views/Company/UserBuilder.vue'),
        meta: { permission: 'users.update' }
    },
    {
        path: '/company/webhooks',
        name: 'CompanyWebhooks',
        component: () => import('@/views/Company/Webhooks.vue'),
        meta: { permission: 'company.settings' }
    },
    {
        path: '/company/webhooks/create',
        name: 'CreateCompanyWebhook',
        component: () => import('@/views/Company/WebhookBuilder.vue'),
        meta: { permission: 'company.settings' }
    },
    {
        path: '/company/webhooks/:webhookId/edit',
        name: 'EditCompanyWebhook',
        component: () => import('@/views/Company/WebhookBuilder.vue'),
        meta: { permission: 'company.settings' }
    },
    {
        path: '/company/settings',
        name: 'CompanySettings',
        component: () => import('@/views/Company/Settings.vue'),
        meta: { permission: 'company.settings' }
    },
    {
        path: '/company/permissions',
        name: 'CompanyPermissions',
        component: () => import('@/views/Company/Permissions.vue'),
        meta: { permission: 'company.settings' }
    },
    {
        path: '/company/backoffice-infos',
        name: 'BackofficeInfos',
        component: () => import('@/views/Company/BackofficeInfos.vue'),
        meta: { permission: 'company.settings' }
    }
]
